"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeOriginOfRect = exports.changeOriginOfPos = void 0;
/* 点・矩形の位置を表す座標の原点を変更する */
var changeOriginOfPos = function (originFrom, originTo) { return function (target) {
    return target.withMutations(function (pos) {
        return pos
            .update('x', function (x) { return x - (originTo.x - originFrom.x); })
            .update('y', function (y) { return y - (originTo.y - originFrom.y); });
    });
}; };
exports.changeOriginOfPos = changeOriginOfPos;
var changeOriginOfRect = function (originFrom, originTo) { return function (target) {
    return target.withMutations(function (pos) {
        return pos
            .update('left', function (left) { return left - (originTo.x - originFrom.x); })
            .update('top', function (top) { return top - (originTo.y - originFrom.y); });
    });
}; };
exports.changeOriginOfRect = changeOriginOfRect;
